"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }
var _lodash = require('lodash');

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _team = require('shared/selectors/team');






















const initialState = {
  conversationDrafts: {},

  selectedTeamKey: null,
  selectedOrgKey: null,
}

 function sessionReducer (
  state = initialState,
  action,
  globalState,
) {
  switch (action.type) {
    case _actionCreators2.default.sendMessageToConversationActions.REQUEST.type: {
      const { payload } = action 
      const { ConversationKey } = payload
      if (!state.conversationDrafts[ConversationKey]) return state

      return {
        ...state,
        conversationDrafts: _lodash.omit.call(void 0, 
          state.conversationDrafts,
          payload.ConversationKey,
        ),
      }
    }

    case _actionCreators2.default.saveConversationDraftAction.type: {
      const { conversationKey, message, mentions = [], fromTemplate } = (action ).payload

      if (!message) {
        return {
          ...state,
          conversationDrafts: _lodash.omit.call(void 0, state.conversationDrafts, conversationKey),
        }
      }

      return {
        ...state,
        conversationDrafts: {
          ...state.conversationDrafts,
          [conversationKey]: fromTemplate ? { message, mentions, fromTemplate } : { message, mentions },
        },
      }
    }

    case _actionCreators2.default.setSelectedOrgAction.type:
      return { ...state, selectedOrgKey: (action ).payload }

    case _actionCreators2.default.setSelectedTeamAction.type: {
      const selectedTeamKey = (action ).payload
      // selectTeams reads only state.dataV2.teams.
      const allTeams = _team.selectTeams.call(void 0, { dataV2: globalState } )
      // A null key reads allTeams['null'] (undefined), as in the JS.
      const team = allTeams[selectedTeamKey ]

      return {
        ...state,
        selectedTeamKey,
        selectedOrgKey: _optionalChain([team, 'optionalAccess', _ => _.OrgKey]) || null,
      }
    }
  }

  return state
} exports.default = sessionReducer;
